"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.replace");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _booking = require("@/api/bookSpace/booking");
var _slideLogin = _interopRequireDefault(require("./slideLogin"));
var _background_login = _interopRequireDefault(require("@/assets/img/background_login.jpg"));
var _title_img = _interopRequireDefault(require("@/assets/img/title_img.png"));
var _user = require("@/api/system/user");
var _version = _interopRequireDefault(require("@/utils/version"));
var _vuex = require("vuex");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Login',
  components: {
    slideLogin: _slideLogin.default
  },
  props: {
    isEditPassword: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      passList: [{
        nameZn: '低',
        nameCh: 'Low'
      }, {
        nameZn: '中',
        nameCh: 'Medium'
      }, {
        nameZn: '高',
        nameCh: 'High'
      }],
      showData: false,
      forgetDialogVisible: false,
      checkedUser: false,
      remberPassward: false,
      imgList: {},
      version: _version.default,
      loginBg: _background_login.default,
      loginTitle: _title_img.default,
      form: {
        activateEmail: '',
        accountNo: ''
      },
      loginRules: {
        accountNo: [{
          required: true,
          message: this.$t('home.messageFour'),
          trigger: 'blur'
        }],
        activateEmail: [{
          required: true,
          message: this.$t('home.messageSix'),
          trigger: 'blur'
        }, {
          required: true,
          type: 'email',
          message: this.$t('home.messageThree'),
          trigger: ['blur', 'change']
        }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: null,
      redirect: undefined,
      otherQuery: {},
      captchaUrl: '',
      showCheckCode: false,
      passwordStrengthText: '',
      passwordStrengthTextEn: '',
      passwordStrengthColor: '',
      radio: 'en'
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    checkCapslock: function checkCapslock(e) {
      var key = e.key;
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z';
    },
    showPwd: function showPwd() {
      var _this = this;
      this.passwordType = '';
      this.$nextTick(function () {
        _this.$refs.password.focus();
      });
    },
    hidePwd: function hidePwd() {
      var _this2 = this;
      this.passwordType = 'password';
      this.$nextTick(function () {
        _this2.$refs.password.focus();
      });
    },
    submitLoginCode: function submitLoginCode(type, isSuccess) {
      this.showData = false;
      if (isSuccess) {
        this.handleLogin();
      }
    },
    handleLoginCode: function handleLoginCode() {
      this.showData = true;
    },
    handleResetPassword: function handleResetPassword() {
      var _this3 = this;
      this.$refs.form.validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(valid) {
          var res;
          return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!valid) {
                  _context.next = 16;
                  break;
                }
                if (!_this3.isEditPassword) {
                  _context.next = 9;
                  break;
                }
                _this3.loading = (0, _utils.load)();
                _context.next = 5;
                return (0, _booking.forgetPwd)(_this3.form);
              case 5:
                res = _context.sent;
                _this3.loading.close();
                _context.next = 15;
                break;
              case 9:
                delete _this3.form.accountNo;
                _this3.loading = (0, _utils.load)();
                _context.next = 13;
                return (0, _booking.forgetAccount)(_this3.form);
              case 13:
                res = _context.sent;
                _this3.loading.close();
              case 15:
                if (res.success) {
                  _this3.forgetDialogVisible = false;
                  _this3.$message({
                    message: _this3.$t('home.sentEmailSuccess'),
                    type: 'success'
                  });
                } else {
                  _this3.$message({
                    message: res.errorMessages[0],
                    type: 'error'
                  });
                }
              case 16:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleClose: function handleClose() {
      this.$refs.form.resetFields();
      this.forgetDialogVisible = false;
    },
    /* 获取验证码 */getCaptcha: function getCaptcha() {
      var _this4 = this;
      (0, _user.captcha)().then(function (res) {
        var data = res; // 返回的数据
        var url = window.URL.createObjectURL(new Blob([data])); // 此url如是图片格式，可赋值<img :src="url"> 做展示
        _this4.captchaUrl = url;
      });
    },
    /* 检验密码的复杂程度 */passwordStrength: function passwordStrength(str) {
      if (!str) {
        this.passwordStrengthText = '';
        this.passwordStrengthTextEn = '';
        return;
      }
      var _color = ['red', 'gray', 'orange', 'green'];
      var msgs = ['密码太短', '低', '中', '高'];
      var msgsEn = ['Too Short', 'Weak', 'Medium', 'Strong'];
      var _strength = 0;
      var _v = str.replace(/^(\s|\u00a0)+|(\s|\u00a0)+$/g, '');
      var _vL = _v.length;
      var i = 0;
      var charStrength = function charStrength(char) {
        // 计算单个字符强度
        if (char >= 48 && char <= 57) {
          // 数字
          return 1;
        }
        if (char >= 97 && char <= 122) {
          // 小写
          return 2;
        } else {
          return 3; // 特殊字符
        }
      };
      if (_vL < 6) {
        // 计算模式
        this.passwordStrengthText = msgs[0];
        this.passwordStrengthTextEn = msgsEn[0];
        this.passwordStrengthColor = _color[0];
      } else {
        for (; i < _vL; i++) {
          // 遍历字符
          _strength += charStrength(_v.toLocaleLowerCase().charCodeAt(i));
        }
        if (_strength < 10) {
          // 强度小于10
          this.passwordStrengthText = msgs[1];
          this.passwordStrengthTextEn = msgsEn[1];
          this.passwordStrengthColor = _color[1];
        }
        if (_strength >= 10 && _strength < 15) {
          this.passwordStrengthText = msgs[2];
          this.passwordStrengthTextEn = msgsEn[2];
          this.passwordStrengthColor = _color[2];
        }
        if (_strength >= 15) {
          this.passwordStrengthText = msgs[3];
          this.passwordStrengthTextEn = msgsEn[3];
          this.passwordStrengthColor = _color[3];
        }
      }
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    }
  }
};